import { t } from '@/plugins/i18n'
export const editableTabs = [
  {
    title: t('全部'),
    name: 'all'
  },
  {
    title: t('未提出'),
    name: '1'
  },
  {
    title: t('已提出'),
    name: '2'
  },
  {
    title: t('已取消'),
    name: '3'
  }
]

export const planStatusDict: any = {
  1: t('未处理，请点击【提出】按钮'),
  2: t('已确认'),
  3: t('已作废')
}

export const planColumns:any = [
  {
    label: t('补货批次号'),
    prop: 'shipmentId',
    align: 'center'
  },
  {
    label: t('补货批次标题'),
    prop: 'title',
    align: 'center'
  },
  {
    label: t('国际发货单号'),
    prop: 'deliveryTaskCode',
    align: 'center',
    width: 200,
    slotName: 'deliveryTaskCode'
  },
  {
    label: t('收货仓'),
    prop: 'receiverWarehouse',
    align: 'center'
  },
  {
    label: t('创建时间'),
    prop: 'createTime',
    align: 'center',
    slotName: 'createTime'
  },
  {
    label: t('状态'),
    prop: 'planStatus',
    align: 'center',
    slotName: 'planStatus'
  }
]

export const planChildColumns:any = [
  {
    label: t('图片'),
    prop: 'productImg',
    slotName: 'productImg'
  },
  {
    label: t('FNSKU/ASIN'),
    prop: 'FnskuAsin',
    align: 'center',
    slotName: 'FnskuAsin'
  },
  {
    label: t('商品名称/Amazon sku'),
    prop: 'productInfo',
    align: 'center',
    slotName: 'productInfo'
  },
  {
    label: t('品名/平台sku'),
    prop: 'productSku',
    align: 'center',
    slotName: 'productSku'
  },
  {
    label: t('平台'),
    prop: 'plat',
    align: 'center',
    slotName: 'plat'
  },
  {
    label: t('计划发货量'),
    prop: 'deliveryNums',
    align: 'center'
  }
]

export const tableConfig = {
  showExpand: true,
  showHandler: true,
  rowKey: 'replenishPlanId',
  setHeight: true,
  handlerConfig: { label: ' ' }
}
